import { useCallback, useEffect, useMemo, useRef, useState } from "react"
import { ErrorCard, LoadingCard, MainContainer, } from "../../components"
import { Button, Autocomplete, AutocompleteItem, Checkbox, Input, addToast, Select, SelectItem, Chip, Card, CardBody, Divider, Modal, NumberInput, Spinner } from "@heroui/react"
import { DatePicker, LocalizationProvider } from "@mui/x-date-pickers"
import dayjs from "dayjs"
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs"
import { apiRoute, ENUM_BILL_TYPE, ENUM_CERTIFIEDLAB, ENUM_CURRENCY_SETTING_VAL, ENUM_ENTRY_TYPE, ENUM_INPUT_TYPE, ENUM_MOD_NAME, ENUM_MOD_PARAMETER, ENUM_TRADE_TYPE, ENUM_TRADEOF_CODE, ENUM_TRADEOF_TYPE, getModMandatory, getModValue, getModVisiblity, linksUrl, URIEncrypt, } from "../../constants/enum"
import { isMobile } from "react-device-detect"
import { useFetchWithBody, usePost, usePostMutateWithSuccess } from "../../api/reactQueryCustomHooks"
import { useDispatch, useSelector } from "react-redux"
import { faCancel, faClose, faDownload, faDownLong, faFile, faFileEdit, faGem, faPenToSquare, faPlus, faSave, faSearchPlus, faSquareXmark, faTrashCan } from "@fortawesome/free-solid-svg-icons"
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"
import { toast } from "react-toastify"
import { useNavigate, useParams } from "react-router-dom"
import { DataGrid } from "@mui/x-data-grid"
import { calculateTotal, funCheckNumber, scrollInput, stickyBottomClass, stickyParentClass } from "../../Utility/utility"
import { Box, Drawer, } from "@mui/material"
import * as XLSX from 'xlsx';
import { saveAs } from "file-saver";
import { resetDetailParams } from "../../state/stockEntrySlice"
import { useModalToast } from "../../components/modalToast/ModalToastContext"

const CreateStockEntry = () => {
    const { compCode, isMultipleCompany, compState, startDate, endDate } = useSelector((state) => state.company)
    const { isNewEntry, detailParams } = useSelector((state) => state.stockEntry)
    const { user } = useSelector((state) => state.auth);
    const navigate = useNavigate();
    const [entryLabel, setEntryLabel] = useState()
    const [selBillType, setSelBillType] = useState('O')
    const [selTradeOf, setSelTradeOf] = useState("")
    const [selPktType, setSelPktType] = useState("")
    const [naviCode, setnaviCode] = useState()
    const [modSettingParams, setModSettingParams] = useState("")
    const [rows, setRows] = useState([])
    const [allRows, setAllRows] = useState([])
    const [openDrawer, setOpenDrawer] = useState(false);
    const [deletedItemRows, setDeletedItemRows] = useState([])
    const [selectedRowId, setSelectedRowId] = useState("")
    const [selImportItem, setSelImportItem] = useState("")
    const [btnLabel, setBtnLabel] = useState("Add")
    const { strdtype, sptype } = useParams();
    const [isExcelImport, setIsExcelImport] = useState(false)
    const [CurrencySetting, setCurrencySetting] = useState("")
    const [lwRatioData, setLwRatioData] = useState([])
    const [mktLotNo, setMktLotNo] = useState("0")
    const [isUseMfgNoAsMktno, setIsUseMfgNoAsMktno] = useState(true)
    const fileInputRef = useRef(null)
    const [submitBtnId, setSubmitBtnId] = useState("")
    const [dupMarketingCode, setDupMarketingCode] = useState([])
    const [dupMfgCode, setDupMfgCode] = useState([])
    const [isMFGIdSingleColum, setIsMFGIdSingleColum] = useState(true)
    const [isMKTIdSingleColum, setIsMKTIdSingleColum] = useState(true)
    const [totalExcelPacket, setTotalExcelPacket] = useState(0)
    const [searchText, setSearchText] = useState("")
    const dispatch = useDispatch()
    const { show } = useModalToast()
    const submitLockRef = useRef(false)


    const { data: masterData = [], isPending: isPendingData, mutate: filterMasterData } = usePost({
        url: apiRoute.stockEntry.entryMasterData,
        queryKey: "masterDatastck",
        onSuccessTasks: (data) => {
            // if (data && Object.keys(data).length > 0) {
            //     if (data.bookMaster.length > 0) {
            //         setFormData({ ...formData, [formField.bookAcId]: data.bookMaster[0].Party_Id, [formField.stockType]: selPktType != "SNG" ? ENUM_STOCK_TYPE.OpeningStock : "" })
            //         funGenVouNo(data.bookMaster[0].Party_Id)
            //     }
            // }
        }
    })

    const { data: labData = [], } = useFetchWithBody({
        url: apiRoute.stockEntry.getLabList,
        queryKey: "LabDataList",

    })
    const { data: stockcheck = [], mutate: checkStock } = usePostMutateWithSuccess({
        url: apiRoute.stockEntry.getOutStockLotPkt,
        queryKey: "fetchOuttockData",


    })
    const refInputPktNo = useRef(null)
    const refInput = useRef(null)

    const { isError, isPending, mutate: funAddUpdate } = usePost({
        url: apiRoute.stockEntry.add_update,
        queryKey: "funAddUpdateStock",
        onSuccessTasks: (data) => {
            dispatch(resetDetailParams());
            if (submitBtnId == 'btnSaveNew') {
                setFormData(emptyFormField)
                setRows([])
                setAllRows([])
                window.location.reload();
            }
            else
                navigate(funGetMasterLink());
            submitLockRef.current = false;
        }
    })

    const { isPending: isLoadingDupPktList, data: dupPktList = [], mutate: funGetDupPktList } = usePostMutateWithSuccess({
        url: apiRoute.stockEntry.getDupPktList,
        queryKey: "funDupPktStock",
    })

    const { data: excelTempData, mutate: filterXlTemplate } = usePost({
        url: apiRoute.stockEntry.getExcelTemplate,
        queryKey: "funExcelTemplateStock",
        // inputData: {
        //     tempname: selPktType=='SNG'?g'StockImport':'StockImportMix'
        // }
    })
    const { isError: isErrorDetail, data: detail = [], mutate: funGetDetail } = usePost({
        url: apiRoute.stockEntry.fetchEntryDetail,
        queryKey: "fetchStockDetail",
    });

    const { isError: isErrorModSet, data: modSetting = [], mutate: filterModSetting } = usePost({
        url: apiRoute.modSetting.getMultiModSetting,
        queryKey: "fetchModSettingStockItem",
    })

    const StockTypeData = [
        { type: "Opening Stock" },
        { type: "New Inward" }
    ]
    const ENUM_STOCK_TYPE =
    {
        OpeningStock: "Opening Stock",
        NewInward: "New Inward"
    }


    //get generted vouno
    const { mutate: generateVouNo } = usePost({
        url: apiRoute.memoEntry.generateVoucherNo,
        queryKey: "generate-vouno-Stock",
        onSuccessTasks: (data) => {

            if (data && data.length > 0) {
                setFormData((prevData) => ({
                    ...prevData,
                    [formField.memoNo]: data[0].new_vou_no,
                }))
            }
        }
    })

    const { data: dupLotPktNo = [], mutate: funChkPktLotNo } = usePostMutateWithSuccess({
        url: apiRoute.memoEntry.checkLotPktNo,
        queryKey: "checkLotNoPktData",

    })

    const { data: mktLotNoData = [], mutate: getMktLotNo } = usePost({
        url: apiRoute.memoEntry.fetchMktlotNo,
        queryKey: "getmktlocdeData",
        onSuccessTasks: (data) => {
            if (!isUseMfgNoAsMktno) {
                if (data && data.length <= 0) {
                    if (!toast.isActive("mktlcode")) {
                        toast.error("Lot No Series Not Found", {
                            "position": "top-center",
                            toastId: "mktlcode"
                        })
                    }
                    setFormData({ ...formData, [formField.memoDate]: null })
                }
                else
                    setMktLotNo(data[0].Mkt_LCode)
            }
            else
                setMktLotNo('0')
        }

    })

    const { data: dupRoughNo = [], mutate: funChkRoughNo } = usePost({
        url: apiRoute.memoEntry.checkRoughNo,
        queryKey: "checkRoughtNo",
        onSuccessTasks: (data) => {
            if (data && data.length > 0) {
                if (data[0].count > 0) {
                    setStockFormData({ ...stockFormData, [RowsField.lotNo]: "" })
                    if (!toast.isActive('toats_chkRoughno')) {
                        toast.error("Duplicate Rough No not Allow", {
                            "position": "top-center",
                            "className": "toast-error",
                            toastId: "toats_chkRoughno",


                        })
                    }

                }
            }

        }

    })

    const { mutate: funChkRoughRef } = usePost({
        url: apiRoute.memoEntry.checkRoughRef,
        queryKey: "checkRoughRef",
        onSuccessTasks: (data) => {

            if (data && data.length > 0) {
                if (data[0].totalcount <= 0) {
                    const id = selectedRowId ?? 0

                    const updatedRows = rows.filter((row) => row.id !== id)
                    let DeletedRow = rows.filter((row) => row.id == id)
                    const rearrangedRows = updatedRows.map((row, index) => {

                        return {
                            ...row,
                            id: index + 1, // Reassign IDs to start from 1 again
                        }
                    })

                    setRows(rearrangedRows)
                    setAllRows(rearrangedRows)
                    setDeletedItemRows([...deletedItemRows, ...DeletedRow])
                }
                else {
                    toast.error("You can't delete as it locked", {
                        position: "top-center",
                        "className": "toast-error",
                    })
                }
            }

        }

    })
    const isSinglePacket = () => {
        if (sptype != "") {
            if (sptype == URIEncrypt.SinglePacket)
                return true
            else
                return false
        }
        else
            return false
    }
    const funGenVouNo = (bookid, billtype) => {

        //  if (isNewEntry && bookid && bookid != "" && billtype && billtype != "" && selTradeOf != "" && selTradeOf != null) {
        if (isNewEntry && bookid && bookid != "" && billtype && billtype != "" && selTradeOf != "" && selTradeOf != null) {
            generateVouNo({
                data: {
                    comp_code: compCode.join(","),
                    vou_type: billtype == 'New Inward' ? 'J' : 'O',
                    book_id: bookid,
                    trade_of: selTradeOf,
                    start_date: dayjs(startDate).format("YYYY-MM-DD"),
                    end_date: dayjs(endDate).format("YYYY-MM-DD")
                }
            })
        }
    }
    useEffect(() => {
        if (isMultipleCompany)
            navigate(linksUrl.dashboard.tradingDashboard)

        const params = [URIEncrypt.Polish, URIEncrypt.Rough, URIEncrypt.Rejection]
        if (!params.includes(String(strdtype))

            || ![URIEncrypt.SinglePacket, URIEncrypt.Mix].includes(sptype))
            navigate(linksUrl.dashboard.tradingDashboard)

        if (strdtype && strdtype != "" && sptype && sptype != "") {
            let t_tradeof = ''
            let t_entryLabel = ''
            let t_pktType = ''
            let t_trdtype = strdtype.toLowerCase()
            let modName = ''

            if (sptype == URIEncrypt.SinglePacket)
                t_pktType = 'SNG'
            else
                t_pktType = 'MIX'

            if (t_trdtype == URIEncrypt.Polish.toLowerCase()) {
                t_tradeof = ENUM_TRADEOF_CODE.Polish
                t_entryLabel = "Polish Diamond "
                modName = isSinglePacket() ? ENUM_MOD_NAME.StockPolishSingle : ENUM_MOD_NAME.StockPolishMix
                setnaviCode(linksUrl.stockEntry.roughDiamond)
            }
            else if (t_trdtype == URIEncrypt.Rough.toLowerCase()) {
                t_tradeof = ENUM_TRADEOF_CODE.Rough
                t_entryLabel = "Rough Diamond "
                modName = isSinglePacket() ? ENUM_MOD_NAME.StockRoughSingle : ENUM_MOD_NAME.StockRoughMix
                setnaviCode(linksUrl.stockEntry.roughDiamond)
            }
            else if (t_trdtype == URIEncrypt.Rejection.toLowerCase()) {
                t_tradeof = ENUM_TRADEOF_CODE.Rejection
                t_entryLabel = "Rejection Diamond "
                modName = isSinglePacket() ? ENUM_MOD_NAME.StockRejetionSingle : ENUM_MOD_NAME.StockRejectionMix
                setnaviCode(linksUrl.stockEntry.roughDiamond)
            }

            setSelTradeOf(t_tradeof)
            setEntryLabel(t_entryLabel)
            setSelPktType(t_pktType)
            filterMasterData({
                data: {
                    compcode: compCode.join(","),
                    tradeof: t_tradeof,
                    billtype: selBillType,

                }
            })
            filterXlTemplate({
                data: {
                    tempname: t_pktType == 'SNG' ? 'StockImport' : 'StockImportMix'
                }
            })
            filterModSetting({
                data: {
                    page_mod: modName,
                    master_mod: ENUM_MOD_NAME.GeneralSettings
                }
            })

            if (!isNewEntry && detailParams && Object.keys(detailParams).length > 0) {
                const { comp_code, transaction_id, bill_type, trade_of } = detailParams
                funGetDetail({
                    data: {
                        compcode: comp_code,
                        transactionid: transaction_id,
                        billtype: bill_type,
                        tradeof: trade_of

                    }
                })
            }
        }
    }, [sptype, strdtype])

    useEffect(() => {
        if (modSetting && Object.keys(modSetting).length > 0) {
            const modData = modSetting.pageData
            const generalData = modSetting.masterData
            setCurrencySetting(getModValue(ENUM_MOD_PARAMETER.GeneralSetting.CurrencyType, generalData) ?? ENUM_CURRENCY_SETTING_VAL.RS)
            const mktSetting = getModMandatory(ENUM_MOD_PARAMETER.GeneralSetting.UseMfgNoAsMktNo, generalData);
            setIsUseMfgNoAsMktno(mktSetting)
            setIsMFGIdSingleColum(getModMandatory(ENUM_MOD_PARAMETER.GeneralSetting.IsMfgIDSingleColumn, generalData) ?? true);
            setIsMKTIdSingleColum(getModMandatory(ENUM_MOD_PARAMETER.GeneralSetting.IsMktIDSingleColumn, generalData) ?? true);

            setModSettingParams({
                Visibility: {
                    [RowsField.itemCode]: getModVisiblity(ENUM_MOD_PARAMETER.MemoEntry.Items, modData) ?? false,
                    [RowsField.lotNo]: getModVisiblity(ENUM_MOD_PARAMETER.MemoEntry.LotNo, modData) ?? false,
                    [RowsField.pktNo]: getModVisiblity(ENUM_MOD_PARAMETER.MemoEntry.PktNo, modData) ?? false,
                    [RowsField.shapeCode]: getModVisiblity(ENUM_MOD_PARAMETER.MemoEntry.Shape, modData) ?? false,
                    [RowsField.colorCode]: getModVisiblity(ENUM_MOD_PARAMETER.MemoEntry.Color, modData) ?? false,
                    [RowsField.purityCode]: getModVisiblity(ENUM_MOD_PARAMETER.MemoEntry.Purity, modData) ?? false,
                    [RowsField.sizeCode]: getModVisiblity(ENUM_MOD_PARAMETER.MemoEntry.Size, modData) ?? false,
                    [RowsField.reportNo]: getModVisiblity(ENUM_MOD_PARAMETER.MemoEntry.ReportNo, modData) ?? false,
                    [RowsField.lab]: getModVisiblity(ENUM_MOD_PARAMETER.MemoEntry.Lab, modData) ?? false,
                    [RowsField.itemDetail]: getModVisiblity(ENUM_MOD_PARAMETER.MemoEntry.ItemDetail, modData) ?? false,
                    [RowsField.lwRatio]: getModVisiblity(ENUM_MOD_PARAMETER.MemoEntry.LxWRatio, modData) ?? false,
                },
                Mandatory: {
                    [RowsField.itemCode]: getModMandatory(ENUM_MOD_PARAMETER.MemoEntry.Items, modData) ?? false,
                    [RowsField.lotNo]: getModMandatory(ENUM_MOD_PARAMETER.MemoEntry.LotNo, modData) ?? false,
                    [RowsField.pktNo]: getModMandatory(ENUM_MOD_PARAMETER.MemoEntry.PktNo, modData) ?? false,
                    [RowsField.shapeCode]: getModMandatory(ENUM_MOD_PARAMETER.MemoEntry.Shape, modData) ?? false,
                    [RowsField.colorCode]: getModMandatory(ENUM_MOD_PARAMETER.MemoEntry.Color, modData) ?? false,
                    [RowsField.purityCode]: getModMandatory(ENUM_MOD_PARAMETER.MemoEntry.Purity, modData) ?? false,
                    [RowsField.sizeCode]: getModMandatory(ENUM_MOD_PARAMETER.MemoEntry.Size, modData) ?? false,
                    [RowsField.itemDetail]: getModMandatory(ENUM_MOD_PARAMETER.MemoEntry.ItemDetail, modData) ?? false,
                    [RowsField.lwRatio]: getModMandatory(ENUM_MOD_PARAMETER.MemoEntry.LxWRatio, modData) ?? false,
                    [RowsField.reportNo]: getModMandatory(ENUM_MOD_PARAMETER.MemoEntry.ReportNo, modData) ?? false,
                    [RowsField.lab]: getModMandatory(ENUM_MOD_PARAMETER.MemoEntry.Lab, modData) ?? false,

                },


            })
        }

    }, [modSetting])

    const net_Amount = useMemo(
        () =>
            calculateTotal({
                data: rows,
                columnName: "amount",
            }),
        [rows]
    )
    const net_AmountD = useMemo(
        () =>
            calculateTotal({
                data: rows,
                columnName: "dAmount",
            }),
        [rows]
    )
    const total_Weight = useMemo(
        () =>
            calculateTotal({
                data: rows,
                columnName: "weight",
            }),
        [rows]
    )
    const total_Rate = useMemo(
        () =>
            calculateTotal({
                data: rows,
                columnName: "rate",
            }),
        [rows]
    )
    const total_Pcs = useMemo(
        () =>
            calculateTotal({
                data: rows,
                columnName: "pcs",
            }),
        [rows]
    )
    const formField = {
        memoNo: "memoNo",
        transId: "transId",
        memoDate: "memoDate",
        locationId: "locationId",
        bookAcId: "bookAcId",
        stockType: "stockType",
        lab: "lab"
    }
    const emptyFormField = Object.keys(formField).reduce((acc, key) => {
        if (key == formField.memoDate)
            acc[key] = new Date()
        else if (key == formField.transId)
            acc[key] = 0

        else acc[key] = ""
        return acc
    }, {})

    const [formData, setFormData] = useState({
        ...emptyFormField
    })

    const RowsField = {
        detailId: "detailId",
        itemCode: "itemCode",
        itemName: "itemName",
        itemDetail: "itemDetail",
        lotNo: "lotNo",
        pktNo: "pktNo",
        sLotNo: "sLotNo",
        sPktNo: "sPktNo",
        updateLotNo: "updateLotNo",
        updatePktNo: "updatePktNo",
        shapeCode: "shapeCode",
        shapeName: "shapeName",
        colorCode: "colorCode",
        colorName: "colorName",
        purityCode: "purityCode",
        purityName: "purityName",
        sizeCode: "sizeCode",
        sizeName: "sizeName",
        lwRatio: "lwRatio",
        pcs: "pcs",
        weight: "weight",
        rate: "rate",
        dRate: "dRate",
        convRate: "convRate",
        dAmount: "dAmount",
        amount: "amount",
        cut: "cut",
        dia: "dia",
        lab: "lab",
        bPcs: "bPcs",
        bWeight: "bWeight",
        reportNo: "reportNo",
        rapRate: "rapRate",
        lessPer: "lessPer",
        stnLength: "stnLenth",
        tblDepth: "tblDepth",
        flrn: "flrn",
        crwnAngle: "crwnAngle",
        certiDate: "certiDate",
        certiNo: "certiNo",
        stoneId: "stoneId",
        gridMktNo: "gridMktNo",
        stkLotNo: "stkLotNo",
        stkPktNo: "stkPktNo",
        isCertiDataExist: "isCertiDataExist"

    }
    const noField = [RowsField.detailId, RowsField.bPcs, RowsField.bWeight, RowsField.pcs, RowsField.weight, RowsField.rate, RowsField.amount, RowsField.tablePer
        , RowsField.rapRate, RowsField.lessPer, RowsField.dia, RowsField.convRate, RowsField.dRate, RowsField.dAmount, RowsField.isCertiDataExist
    ]
    const emptyRowsField = Object.keys(RowsField).reduce((acc, key) => {
        if (noField.includes(key))
            acc[key] = 0
        else if (key == RowsField.certiDate)
            acc[key] = null
        else acc[key] = ""
        return acc
    }, {})
    const [stockFormData, setStockFormData] = useState({
        ...emptyRowsField
    })

    const inputBoxes = {
        Row1: [
            {
                id: formField.memoNo,
                name: formField.memoNo,
                placeholder: "Memo No.",
                type: ENUM_INPUT_TYPE.text,
                size: "sm",
                label: "",
                isrequired: true,
            },
            {
                id: formField.memoDate,
                name: formField.memoDate,
                placeholder: "Memo Date.",
                type: ENUM_INPUT_TYPE.date,
                size: "sm",
                label: "",
                isrequired: true,
            },],
        Row2: [
            {
                id: formField.bookAcId,
                name: formField.bookAcId,
                placeholder: "Book Name",
                type: ENUM_INPUT_TYPE.autocomplete,
                size: "sm",
                label: "",
                data: masterData && masterData?.bookMaster ? masterData?.bookMaster : [],
                itemkey: "Party_Id",
                itemvalue: "Party_Name",
                isrequired: true,
            },
            {
                id: formField.locationId,
                name: formField.locationId,
                placeholder: "Location",
                type: ENUM_INPUT_TYPE.autocomplete,
                size: "sm",
                label: "",
                data: masterData && masterData?.locationMaster ? masterData?.locationMaster : [],
                itemkey: "Party_Id",
                itemvalue: "Party_Name",
                isrequired: true,
            },
        ],
        Row3: [
            {
                id: formField.stockType,
                name: formField.stockType,
                placeholder: "Stock Type",
                type: ENUM_INPUT_TYPE.autocomplete,
                size: "sm",
                label: "",
                data: StockTypeData,
                itemkey: "type",
                itemvalue: "type",
                isrequired: true,
            },
            {
                id: formField.lab,
                name: formField.lab,
                placeholder: "Lab",
                type: ENUM_INPUT_TYPE.autocomplete,
                size: "sm",
                label: "",
                data: ENUM_CERTIFIEDLAB.filter((ele) => ele.key != "CUSTOM"), // labData ? labData : [],
                itemkey: "key",
                itemvalue: "value",
                isrequired: false,
            },
        ]
    }
    const stockInputBoxes = {
        Row1: [
            {
                id: RowsField.itemCode,
                name: RowsField.itemCode,
                placeholder: "Item",
                type: ENUM_INPUT_TYPE.autocomplete,
                size: "sm",
                label: "",
                data: masterData && masterData?.itemMaster ? masterData?.itemMaster : [],
                itemkey: "Item_Code",
                itemvalue: "Item_Desc",
                readonly: false,
                isrequired: false,
            },
            {
                id: RowsField.itemDetail,
                name: RowsField.itemDetail,
                placeholder: "Item Detail",
                type: ENUM_INPUT_TYPE.text,
                size: "sm",
                label: "",
                readonly: false,
                isrequired: false,
            },

        ], Row2: [
            {
                id: RowsField.lotNo,
                name: RowsField.lotNo,
                placeholder: selPktType != 'SNG' && selTradeOf == 'R' ? "Rought No" : "Lot No",
                type: ENUM_INPUT_TYPE.text,
                size: "sm",
                label: "",
                readonly: false,
                isrequired: false,
            },
            {
                id: RowsField.pktNo,
                name: RowsField.pktNo,
                placeholder: "Pkt No.",
                type: ENUM_INPUT_TYPE.text,
                size: "sm",
                label: "",
                readonly: false,
                isrequired: false,
            },

        ],
        Row3: [

            {
                id: RowsField.shapeCode,
                name: RowsField.shapeCode,
                placeholder: "Shape",
                type: ENUM_INPUT_TYPE.autocomplete,
                size: "sm",
                label: "",
                data: masterData && masterData?.shapeMaster ? masterData?.shapeMaster : [],
                itemkey: "S_Code",
                itemvalue: "S_Name",
                readonly: false,
                isrequired: false,
            },
            {
                id: RowsField.colorCode,
                name: RowsField.colorCode,
                placeholder: "Color",
                type: ENUM_INPUT_TYPE.autocomplete,
                size: "sm",
                label: "",
                data: masterData && masterData?.colorMaster ? masterData?.colorMaster : [],
                itemkey: "Sh_Code",
                itemvalue: "Sh_Name",
                readonly: false,
                isrequired: false,
            },
            {
                id: RowsField.purityCode,
                name: RowsField.purityCode,
                placeholder: "Purity",
                type: ENUM_INPUT_TYPE.autocomplete,
                size: "sm",
                label: "",
                data: masterData && masterData?.purityMaster ? masterData?.purityMaster : [],
                itemkey: "Q_Code",
                itemvalue: "Q_Name",
                readonly: false,
                isrequired: false,
            },
            {
                id: RowsField.sizeCode,
                name: RowsField.sizeCode,
                placeholder: "Size",
                type: ENUM_INPUT_TYPE.autocomplete,
                size: "sm",
                label: "",
                data: masterData && masterData?.sizeMaster ? masterData?.sizeMaster : [],
                itemkey: "Sz_Code",
                itemvalue: "Sz_Name",
                readonly: false,
                isrequired: false,
            },
            {
                id: RowsField.lwRatio,
                name: RowsField.lwRatio,
                placeholder: "LxW Ratio",
                type: ENUM_INPUT_TYPE.autocomplete,
                size: "sm",
                label: "",
                data: lwRatioData ? lwRatioData : [],
                itemkey: "LwCode",
                itemvalue: "LwCode",
                readonly: false,
                isrequired: false,
                // id: RowsField.lwRatio,
                // name: RowsField.lwRatio,
                // placeholder: "LxW Ratio",
                // type: ENUM_INPUT_TYPE.text,
                // size: "sm",
                // label: "",
                // readonly: false,
                // isrequired: false,
            }
        ],
        Row4: [

            {
                id: RowsField.lab,
                name: RowsField.lab,
                placeholder: "Lab",
                type: ENUM_INPUT_TYPE.text,
                size: "sm",
                label: "",
                readonly: false,
                isrequired: false,
            },
            {
                id: RowsField.reportNo,
                name: RowsField.reportNo,
                placeholder: "Report No",
                type: ENUM_INPUT_TYPE.text,
                size: "sm",
                label: "",
                readonly: false,
                isrequired: false,
            },

        ],
        Row5: [
            {
                id: RowsField.pcs,
                name: RowsField.pcs,
                placeholder: "Pcs",
                type: ENUM_INPUT_TYPE.number,
                size: "sm",
                label: "",
                readonly: false,
                isrequired: false,
                color: "primary"
            },
            {
                id: RowsField.weight,
                name: RowsField.weight,
                placeholder: "Weight",
                type: ENUM_INPUT_TYPE.number,
                size: "sm",
                label: "",
                readonly: false,
                isrequired: false,
                color: "success"
            },
            {
                id: RowsField.dRate,
                name: RowsField.dRate,
                placeholder: "Rate($)",
                type: ENUM_INPUT_TYPE.number,
                size: "sm",
                label: "",
                isrequired: false,
                readonly: false,
                color: "danger"
            },
            {
                id: RowsField.dAmount,
                name: RowsField.dAmount,
                placeholder: "Amount($)",
                type: ENUM_INPUT_TYPE.number,
                size: "sm",
                label: "",
                isrequired: false,
                readonly: true,
                color: "warning"
            },
            {
                id: RowsField.convRate,
                name: RowsField.convRate,
                placeholder: "Conv Rate",
                type: ENUM_INPUT_TYPE.number,
                size: "sm",
                label: "",
                readonly: false,
                isrequired: false,
                color: "success"
            },

            {
                id: RowsField.rate,
                name: RowsField.rate,
                placeholder: "Rate",
                type: ENUM_INPUT_TYPE.number,
                size: "sm",
                label: "",
                readonly: false,
                isrequired: false,
                color: "danger"
            },
            {
                id: RowsField.amount,
                name: RowsField.amount,
                placeholder: "Amount",
                type: ENUM_INPUT_TYPE.number,
                size: "sm",
                label: "",
                isrequired: false,
                readonly: true,
                color: "warning"
            },

        ]

    }

    const getLwRatioByShape = (shape) => {
        if (masterData && Object.keys(masterData).length > 0)
            return masterData?.lwMaster.filter((ele) => ele.S_Code == shape)
        else
            return []
    }

    const funGetName = (columName, value) => {
        let name_val = ""
        let tempData = []
        let findData = []

        if (masterData && Object.keys(masterData).length > 0) {

            if (columName == RowsField.itemCode && value != "" && value != null) {
                tempData = masterData.itemMaster
                findData = tempData.filter((ele) => ele.Item_Code == value)
                name_val = findData[0]?.Item_Desc ?? ''
            }
            else if (columName == RowsField.shapeCode && value != "" && value != null) {
                tempData = masterData.shapeMaster
                findData = tempData.filter((ele) => ele.S_Code == value)
                name_val = findData[0]?.S_Name ?? ''
            }
            else if (columName == RowsField.colorCode && value != "" && value != null) {
                tempData = masterData.colorMaster
                findData = tempData.filter((ele) => ele.Sh_Code == value)
                name_val = findData[0]?.Sh_Name ?? ''
            }
            else if (columName == RowsField.purityCode && value != "" && value != null) {
                tempData = masterData.purityMaster
                findData = tempData.filter((ele) => ele.Q_Code == value)
                name_val = findData[0]?.Q_Name ?? ''
            }
            else if (columName == RowsField.sizeCode && value != "" && value != null) {

                tempData = masterData.sizeMaster
                findData = tempData.filter((ele) => ele.Sz_Code == value)
                name_val = findData[0]?.Sz_Name ?? ''
            }
        }

        return name_val;

    }
    useEffect(() => {
        if (masterData && Object.keys(masterData).length > 0) {
            setLwRatioData(masterData.lwMaster)
        }
    }, [masterData])

    let gridData = []
    if (!isNewEntry && detailParams && Object.keys(detailParams).length > 0) {
        if (detail && detail?.itemDetail && detail?.itemDetail?.length > 0) {

            gridData = detail?.itemDetail.map((item, i) => {
                return {
                    id: ++i,
                    itemCode: item?.Item_Code ?? "",
                    itemDetail: item?.Item_Det ?? "",
                    pcs: item?.Nos ?? 0,
                    weight: item?.Weight ?? 0,
                    rate: item?.Rate ?? 0,
                    amount: item?.Amount ?? 0,
                    detailId: item?.DetailId ?? 0,
                    dRate: item?.S_Rate ?? 0,
                    dAmount: item?.AmountD ?? 0,
                    lotNo: item?.L_Code ?? "",
                    pktNo: item?.PktNo ?? "",
                    sLotNo: item?.SL_Code ?? "",
                    sPktNo: item?.SPktNo ?? "",
                    lwRatio: item?.Lw_Code ?? "",
                    shapeCode: item?.S_Code ?? "",
                    colorCode: item?.Sh_Code ?? "",
                    purityCode: item?.Q_Code ?? "",
                    sizeCode: item?.Sz_Code ?? "",
                    itemName: item?.ItemName ?? "",
                    shapeName: item?.ShapeName ?? "",
                    colorName: item?.ColorName ?? "",
                    purityName: item?.PurityName ?? "",
                    sizeName: item?.SizeName ?? "",
                    flrn: item?.Flrn ?? "",
                    reportNo: item?.ReportNo ?? "",
                    lab: item?.Lab ?? "",
                    updateLotNo: !isUseMfgNoAsMktno ? item?.Stk_LCode ?? 0 : item?.L_Code ?? 0, //
                    updatePktNo: !isUseMfgNoAsMktno ? item?.Stk_PktNo ?? 0 : item?.PktNo ?? 0, //!isUseMfgNoAsMktno? item?.Stk_PktNo ??
                    bWeight: item?.BWeight ?? 0,
                    bPcs: item?.BPcs ?? 0,
                    gridMktNo: item?.Stk_LCode + '-' + item?.Stk_PktNo,
                    isCertiDataExist: item?.IsCertiEntry ?? 0
                    // refDetId: item?.RefDetId ?? 0,
                    // retWeight: item?.Ret_Weight ?? 0,
                    // invWeight: item?.Inv_Weight ?? 0,
                }
            })
        }
    }
    console.log(rows)
    const handleChange = (e) => {
        const { value, id, } = e.target
        setFormData({ ...formData, [id]: value })
    }
    const handleStockChange = (e) => {
        const { value, name } = e.target

        if (name == RowsField.rate || name == RowsField.weight || name == RowsField.dRate || name == RowsField.convRate) {
            let t_rate = name == RowsField.rate ? value : stockFormData.rate ?? 0
            let t_weight = name == RowsField.weight ? value : stockFormData.weight ?? 0
            let t_DRate = name == RowsField.dRate ? value : stockFormData.dRate ?? 0
            let t_Amount = 0
            let t_DAmount = 0
            let tempVal = 0
            let conv_rate = name == RowsField.convRate ? value : stockFormData.convRate ?? 0
            if (CurrencySetting != ENUM_CURRENCY_SETTING_VAL.RS) {
                //&& CurrencySetting == ENUM_CURRENCY_SETTING_VAL.Dollar
                if ((name == RowsField.dRate || name == RowsField.convRate)) {
                    tempVal = parseFloat(t_DRate) * parseFloat(conv_rate)
                    t_rate = funCheckNumber(tempVal).toFixed(2)
                }
                else if (name == RowsField.rate || name == RowsField.convRate) {
                    tempVal = parseFloat(t_rate) / parseFloat(conv_rate)
                    t_DRate = funCheckNumber(tempVal).toFixed(2)
                }
            }

            tempVal = parseFloat(t_rate) * parseFloat(t_weight)
            t_Amount = funCheckNumber(tempVal).toFixed(2)
            tempVal = parseFloat(t_DRate) * parseFloat(t_weight)
            t_DAmount = funCheckNumber(tempVal).toFixed(2)
            //  amount = parseFloat(t_weight) * parseFloat(t_rate)


            //  if (CurrencySetting != ENUM_CURRENCY_SETTING_VAL.RS) {
            //  if (name != RowsField.dRate)
            //    setStockFormData({ ...stockFormData, [name]: value, amount: t_Amount, dAmount: t_DAmount, dRate: t_DRate })
            // if (name != RowsField.rate)
            //  setStockFormData({ ...stockFormData, [name]: value, amount: t_Amount, dAmount: t_DAmount, rate: t_rate })
            // }
            // else
            setStockFormData({ ...stockFormData, [name]: value, amount: t_Amount, dAmount: t_DAmount, dRate: t_DRate, rate: t_rate })
        }
        else {
            // if (!isUseMfgNoAsMktno) {
            //     let id = name
            //     if (name == RowsField.pktNo)
            //         id = RowsField.sPktNo
            //     if (name == RowsField.lotNo)
            //         id = RowsField.sLotNo
            //     setStockFormData({ ...stockFormData, [id]: value, [RowsField.lotNo]: mktLotNo })
            // }
            // else {
            //     let t_spktno = formField[RowsField.pktNo]
            //     let t_slotno = formField[RowsField.lotNo]
            //     if (name == RowsField.pktNo)
            //         t_spktno = value
            //     if (name == RowsField.lotNo)
            //         t_slotno = value
            setStockFormData({ ...stockFormData, [name]: value })

        }

    }

    const handleBlur = (e) => {
        const { name, value } = e.target
        if (name == RowsField.lotNo || name == RowsField.pktNo) {
            const newRows = [...rows]

            let t_lotno = name == RowsField.lotNo ? value : stockFormData.lotNo
            let t_pktno = name == RowsField.pktNo ? value : stockFormData.pktNo


            if (selPktType == 'SNG' && t_lotno != "" && t_pktno != "") {

                //update time id check 

                if (!isNewEntry) {
                    let old_lotNO = ''
                    let old_pktNO = ''
                    const fil = rows.filter((ele) => ele.id == selectedRowId)
                    old_lotNO = fil[0]?.updateLotNo ?? ''
                    old_pktNO = fil[0]?.updatePktNo ?? ''
                    if (t_lotno === old_lotNO && t_pktno === old_pktNO) {
                        // console.log("No change → skip funChkPktLotNo");
                        return;
                    }

                }


                let d = rows.filter((ele) => ele.lotNo == t_lotno && ele.pktNo == t_pktno)
                if (selectedRowId && selectedRowId != "") {
                    d = rows.filter((ele) => ele.lotNo == t_lotno && ele.pktNo == t_pktno && ele.id != selectedRowId)

                }

                if (d && d.length > 0) {
                    setStockFormData({ ...stockFormData, [RowsField.pktNo]: "", [RowsField.lotNo]: "" })
                    if (!toast.isActive('toats_chkpktlotgrid') && !toast.isActive('toats_chkpktlot')) {
                        toast.error("Duplicate Pkt No And Lot No Not Allow", {
                            "position": "top-center",
                            "className": "toast-error",
                            toastId: "toats_chkpktlotgrid",
                        })
                    }
                }


                funChkPktLotNo({
                    data: {
                        compcode: compCode.join(","),
                        lotno: t_lotno,
                        pktno: t_pktno,
                        mktlcode: mktLotNo || '0'
                    },
                    onSuccess: (data) => {
                        if (data && data.length > 0) {
                            if (data[0].count > 0) {

                                setStockFormData({ ...stockFormData, [RowsField.pktNo]: "", [RowsField.lotNo]: "" })
                                if (!toast.isActive('toats_chkpktlot')) {
                                    toast.error("Duplicate Pkt No And Lot No Not Allow", {
                                        "position": "top-center",
                                        "className": "toast-error",
                                        toastId: "toats_chkpktlot",
                                    })
                                }

                            }
                        }
                    }

                })
            }
            else if (selPktType != 'SNG' && t_lotno != "") {
                funChkRoughNo({
                    data: {
                        compcode: compCode.join(","),
                        roughno: t_lotno,
                    }
                })
            }
        }

    }

    const handleAddRow = () => {
        setSelectedRowId("")
        if (selPktType == 'SNG') {
            if (!isUseMfgNoAsMktno && (mktLotNo == '' || mktLotNo == null || mktLotNo == '0')) {
                toast.error("Lot No Series Not Found", {
                    "position": "top-center",
                })
                return;
            }
            setStockFormData({ ...emptyRowsField, pcs: 1 })
        }
        else
            setStockFormData({ ...emptyRowsField })
        setOpenDrawer(true)
        setBtnLabel("Add")

    }
    const [errors, setErrors] = useState({})

    const validateForm = () => {
        const newErrors = {}

        // Validate username
        if (setColumnRequired(RowsField.itemDetail)) {
            if (stockFormData[RowsField.itemDetail].trim() == "") {
                newErrors[RowsField.itemDetail] = "Item Detail required"
            }
        }
        if (setColumnRequired(RowsField.lotNo)) {
            if (stockFormData[RowsField.lotNo].trim() == "") {
                newErrors[RowsField.lotNo] = "LotNo /Rough No required"
            }
        }
        if (setColumnRequired(RowsField.pktNo)) {
            if (stockFormData[RowsField.pktNo].trim() == "") {
                newErrors[RowsField.pktNo] = "PktNo required"
            }
        }
        if (setColumnRequired(RowsField.itemCode)) {
            if (stockFormData[RowsField.itemCode] == "" || stockFormData[RowsField.itemCode] == "0" || stockFormData[RowsField.itemCode] == null) {
                newErrors[RowsField.itemCode] = "Item required"
            }
        }
        if (setColumnRequired(RowsField.shapeCode)) {
            if (stockFormData[RowsField.shapeCode] == "" || stockFormData[RowsField.shapeCode] == "0" || stockFormData[RowsField.shapeCode] == null) {
                newErrors[RowsField.shapeCode] = "Shape required"
            }
        }
        if (setColumnRequired(RowsField.colorCode)) {
            if (stockFormData[RowsField.colorCode] == "" || stockFormData[RowsField.colorCode] == "0" || stockFormData[RowsField.colorCode] == null) {
                newErrors[RowsField.colorCode] = "Color required"
            }
        }
        if (setColumnRequired(RowsField.purityCode)) {
            if (stockFormData[RowsField.purityCode] == "" || stockFormData[RowsField.purityCode] == "0" || stockFormData[RowsField.purityCode] == null) {
                newErrors[RowsField.purityCode] = "Purity required"
            }

        }
        if (setColumnRequired(RowsField.sizeCode)) {
            if (stockFormData[RowsField.sizeCode] == "" || stockFormData[RowsField.sizeCode] == "0" || stockFormData[RowsField.sizeCode] == null) {
                newErrors[RowsField.sizeCode] = "Size required"
            }
        }
        if (setColumnRequired(RowsField.pcs)) {
            if (stockFormData[RowsField.pcs] == "" || stockFormData[RowsField.pcs] <= 0) {
                newErrors[RowsField.pcs] = "Pcs required"
            }
        }
        if (stockFormData[RowsField.weight] == "" || stockFormData[RowsField.weight] <= 0) {
            newErrors[RowsField.weight] = "Weight required"
        }
        if (stockFormData[RowsField.rate] == "" || stockFormData[RowsField.rate] <= 0) {
            newErrors[RowsField.rate] = "Rate required"
        }


        setErrors(newErrors)

        // Return true if there are no errors
        return Object.keys(newErrors).length === 0
    }

    useEffect(() => {
        validateForm()
    }, [stockFormData])


    const funMktLotNo = (date) => {

        if (isNewEntry && !isUseMfgNoAsMktno && selPktType == 'SNG') {
            getMktLotNo({
                data: {
                    chaldate: date
                }
            })
        }
    }
    useEffect(() => {
        funMktLotNo(dayjs(Date()).format("YYYY-MM-DD"))

    }, [isUseMfgNoAsMktno])
    const [isFocus, setIsFocus] = useState(false)

    const handleAddStock = () => {
        const validate_form = validateForm()
        if (validate_form) {
            let isDuplicate = false
            if (selPktType != 'SNG')
                isDuplicate = isDuplicateExcludingId(stockFormData, rows)
            if (!isDuplicate) {
                if (selectedRowId && selectedRowId != "") {
                    const currentDataIndex = rows.findIndex((ele) => ele.id == selectedRowId);
                    const updateData = { ...rows[currentDataIndex], ...stockFormData }
                    const newData = [...rows]
                    newData[currentDataIndex] = updateData
                    setSelectedRowId("")
                    setRows(newData)
                    setAllRows(newData)
                    setOpenDrawer(false)
                    // toast.success("Stock Updated.....", {
                    //     "position": "top-center"
                    // })

                }
                else {
                    //if(ref)
                    setIsFocus(true)
                    // if (selPktType == 'SNG') {
                    //     document.querySelector("#pktNo").focus()
                    //          if (refInputPktNo.current)
                    //             refInputPktNo.current.focus()
                    // }

                    const newRow = { id: rows.length + 1, ...stockFormData, }
                    setRows([...rows, newRow])
                    setAllRows([...allRows, newRow])
                    const lastRow = stockFormData
                    setStockFormData({ ...lastRow, pktNo: "", weight: 0, rate: 0, dRate: 0, dAmount: 0, amount: 0 })
                    toast.success("Stock Added.....", {
                        "position": "top-center",
                        onClose: () => {
                            const pktInput = document.querySelector("#pktNo");
                            if (pktInput && typeof pktInput.focus === 'function') {
                                pktInput.focus();
                            }
                            if (refInputPktNo.current && typeof refInputPktNo.current.focus === 'function')
                                refInputPktNo.current.focus();
                        }
                    })

                }

            }
            else {
                toast.error("Duplicate values not allow", {
                    "position": "top-center"
                })
            }
        }
        else {
            if (!toast.isActive('toats_chkreqrd')) {
                toast.error("Fill all required values", {
                    "position": "top-center",
                    "className": "toast-error",
                    toastId: "toats_chkreqrd",
                })
            }
        }
    }
    useEffect(() => {
        if (selPktType == 'SNG') {
            document.querySelector("#pktNo").focus();
            if (refInputPktNo.current)
                refInputPktNo.current.focus()
        }
    }, [isFocus])
    const handleAutoCompleteChange = (value, id, name) => {

        if (name == formField.locationId || name == formField.lab || name == formField.bookAcId || name == formField.stockType) {

            if (name == formField.bookAcId)
                funGenVouNo(value, formData[formField.stockType])
            else if (name == formField.stockType)
                funGenVouNo(formData[formField.bookAcId], value)


            // let t_stockType= formData[formField.stockType]
            // if(name == formField.stockType)
            //     t_stockType=value
            // let t_billTpe=''
            // if(t_stockType==ENUM_STOCK_TYPE.NewInward)
            //     t_billTpe='J'
            // if(t_stockType==ENUM_STOCK_TYPE.OpeningStock)
            //     t_billTpe='O'


            // else if (name == formField.stockType && formData[formField.bookAcId] != "")
            //     funGenVouNo(formData[formField.bookAcId],t_billTpe )

            setFormData({ ...formData, [name]: value })
        }
        else {
            let name_key = ""
            if (name == RowsField.itemCode)
                name_key = RowsField.itemName
            else if (name == RowsField.shapeCode) {
                name_key = RowsField.shapeName
                setLwRatioData(getLwRatioByShape(value))
            }
            else if (name == RowsField.colorCode)
                name_key = RowsField.colorName
            else if (name == RowsField.purityCode)
                name_key = RowsField.purityName
            else if (name == RowsField.sizeCode)
                name_key = RowsField.sizeName

            let name_val = funGetName(name, value)
            if (name == RowsField.lwRatio) {
                name_key = RowsField.lwRatio
                name_val = value

            }
            setStockFormData({ ...stockFormData, [name]: value, [name_key]: name_val })
        }


    }

    const isDuplicateExcludingId = (target, arr) => {
        return arr.some(item => {
            // Skip the same object by id
            const excludeKey = [RowsField.pcs, RowsField.weight, RowsField.weight, RowsField.amount]
            if (item.id === target.id) return false;

            // Compare all keys except 'id'
            return Object.keys(target).every(key => {
                if (selectedRowId && selectedRowId > 0) {
                    if (excludeKey.includes(key) && key != 'id') return true;
                }
                else
                    if (excludeKey.includes(key)) return true;
                return item[key] === target[key];
            });
        });
    };
    const handleDeleteRow = (id) => {

        const updatedRows = rows.filter((row) => row.id !== id)
        let DeletedRow = rows.filter((row) => row.id == id)

        if (DeletedRow[0].bPcs <= 0 && DeletedRow[0].bWeight <= 0 && DeletedRow[0].detailId > 0 && selPktType == 'SNG') {
            toast.error(" Stock can not be delete as it locked", {
                "position": "top-center",
                "className": "toast-error",
            })
        }
        else if (selTradeOf == "R" && selBillType == 'O' && selPktType != "SNG" && !isNewEntry) {
            setSelectedRowId(id)
            funChkRoughRef({
                data: {
                    comp_code: compCode.join(","),
                    transaction_id: formData.transId,
                    rough_no: DeletedRow[0].lotNo
                }
            })
        }

        else {
            const rearrangedRows = updatedRows.map((row, index) => {
                return {
                    ...row,
                    id: index + 1
                } // Reassign IDs to start from 1 again
            })
            setRows(rearrangedRows)
            setAllRows(rearrangedRows)
            setDeletedItemRows([...deletedItemRows, ...DeletedRow])
        }
    }
    const handleEditRow = (id) => {
        const editRow = rows.filter((row) => row.id == id)
        if (editRow[0].isCertiDataExist == 1 || (editRow[0].bPcs <= 0 && editRow[0].bWeight <= 0 && !isNewEntry && selPktType == 'SNG')) {
            show(<div className="text-lime-500"> Stock can not be edit as it locked <div className="text-red-700">Certification data has been updated or the item has already been sold.</div></div>)
            //, {
            //     "position": "top-center",
            //     "className": "toast-error",
            // })
        }
        else {
            setLwRatioData(getLwRatioByShape(editRow[0]?.shapeCode ?? ''))
            setStockFormData(...editRow)
            setSelectedRowId(id)
            setOpenDrawer(true)
            setBtnLabel("Edit")
        }
    }
    const funIsFooter = (id) => {
        if (id == 100000)
            return true
        else
            return false
    }
    const setCurrencyColumnVisiblity = (column) => {

        const RsCol = [RowsField.rate, RowsField.amount]
        const DCol = [RowsField.dRate, RowsField.dAmount, RowsField.convRate]
        if (CurrencySetting == ENUM_CURRENCY_SETTING_VAL.RS && RsCol.includes(column))
            return true
        else if (CurrencySetting == ENUM_CURRENCY_SETTING_VAL.Dollar && DCol.includes(column))
            return true
        else if (CurrencySetting == ENUM_CURRENCY_SETTING_VAL.DUAL)
            return true
        else
            return false
    }
    console.log(detail)
    const itemGridHeadClass = "bill-grid-style"
    const columns = [
        {
            field: RowsField.id,
            headerName: "Action",
            width: 70,
            headerAlign: "center",
            headerClassName: itemGridHeadClass,

            renderCell: ({ row }) => (
                <div>
                    {funIsFooter(row.id) ? <div className="text-center"> Total</div> :
                        <div className="flex justify-evenly" ><h6> {row.id}</h6>
                            <strong>
                                <FontAwesomeIcon
                                    color="red"
                                    className={` mx-2 cursor-pointer`}
                                    onClick={() => handleDeleteRow(row.id)}
                                    icon={faSquareXmark}
                                ></FontAwesomeIcon>

                                <FontAwesomeIcon
                                    color="green"
                                    className={`  cursor-pointer`}
                                    onClick={() => handleEditRow(row.id)}
                                    icon={faPenToSquare}
                                ></FontAwesomeIcon>


                            </strong>
                        </div>}
                </div>
            ),
        },
        {
            field: RowsField.itemDetail,
            headerName: "Item Detail",
            minWidth: 100,
            flex: 1,
            headerAlign: "center",
            headerClassName: itemGridHeadClass,
            align: "center",
            renderCell: ({ row }) =>
            (
                <div>
                    {funIsFooter(row.id) ? "" : row[RowsField.itemDetail]
                    }
                </div>)
        },
        {
            field: RowsField.itemCode,
            headerName: "Item",
            minWidth: 150,
            flex: 1,
            headerAlign: "center",
            headerClassName: itemGridHeadClass,
            align: "center",
            renderCell: ({ row }) =>
            (
                <div>
                    {funIsFooter(row.id) ? "" : row[RowsField.itemName]
                    }
                </div>)
        },
        {
            field: RowsField.lotNo,
            headerName: "Lot No",
            minWidth: 100,
            flex: 1,
            headerAlign: "center",
            headerClassName: itemGridHeadClass,
            align: "center",
            renderCell: ({ row }) =>
            (
                <div>
                    {funIsFooter(row.id) ? "" : row[RowsField.lotNo]
                    }
                </div>)
        },
        {
            field: RowsField.pktNo,
            headerName: "Pkt No",
            minWidth: 100,
            flex: 1,
            headerAlign: "center",
            headerClassName: itemGridHeadClass,
            align: "center",
            renderCell: ({ row }) =>
            (
                <div>
                    {
                        funIsFooter(row.id) ? "" : row[RowsField.pktNo]
                    }
                </div>)
        },
        {
            field: RowsField.gridMktNo,
            headerName: "Mkt No",
            minWidth: 100,
            flex: 1,
            headerAlign: "center",
            headerClassName: itemGridHeadClass,
            align: "center",
            renderCell: ({ row }) =>
            (
                <div>
                    {
                        funIsFooter(row.id) ? "" : row[RowsField.gridMktNo]
                    }
                </div>)
        },
        {
            field: RowsField.sLotNo,
            headerName: "Mfg Lot No",
            minWidth: 100,
            flex: 1,
            headerAlign: "center",
            headerClassName: itemGridHeadClass,
            align: "center",
            renderCell: ({ row }) =>
            (
                <div>
                    {funIsFooter(row.id) ? "" : row[RowsField.sLotNo]
                    }
                </div>)
        },
        {
            field: RowsField.sPktNo,
            headerName: "Mfg Pkt No",
            minWidth: 100,
            flex: 1,
            headerAlign: "center",
            headerClassName: itemGridHeadClass,
            align: "center",
            renderCell: ({ row }) =>
            (
                <div>
                    {
                        funIsFooter(row.id) ? "" : row[RowsField.sPktNo]
                    }
                </div>)
        },
        {
            field: RowsField.shapeCode,
            headerName: "Shape",
            minWidth: 150,
            flex: 1,
            headerAlign: "center",
            headerClassName: itemGridHeadClass,
            align: "center",
            renderCell: ({ row }) =>
            (
                <div>
                    {funIsFooter(row.id) ? "" : row[RowsField.shapeName]
                    }
                </div>)
        },
        {
            field: RowsField.colorCode,
            headerName: "Color",
            minWidth: 100,
            flex: 1,
            headerAlign: "center",
            headerClassName: itemGridHeadClass,
            align: "center",
            renderCell: ({ row }) =>
            (
                <div>
                    {funIsFooter(row.id) ? "" : row[RowsField.colorName] //funGetName(RowsField.colorCode, row.colorCode)
                    }
                </div>)
        },
        {
            field: RowsField.purityCode,
            headerName: "Purity",
            minWidth: 100,
            flex: 1,
            headerAlign: "center",
            headerClassName: itemGridHeadClass,
            align: "center",
            renderCell: ({ row }) =>
            (
                <div>
                    {funIsFooter(row.id) ? "" : row[RowsField.purityName]
                    }
                </div>)
        }, {
            field: RowsField.sizeCode,
            headerName: "Size",
            minWidth: 100,
            flex: 1,
            headerAlign: "center",
            headerClassName: itemGridHeadClass,
            align: "center",
            renderCell: ({ row }) =>
            (
                <div>
                    {funIsFooter(row.id) ? "" : row[RowsField.sizeName]
                    }
                </div>)
        },
        {
            field: RowsField.lwRatio,
            headerName: "LxW Ratio",
            minWidth: 100,
            flex: 1,
            headerAlign: "center",
            headerClassName: itemGridHeadClass,
            align: "center",
            renderCell: ({ row }) =>
            (
                <div>
                    {funIsFooter(row.id) ? "" : row[RowsField.lwRatio]
                    }
                </div>)
        },
        {
            field: RowsField.pcs,
            headerName: "Pcs",
            minWidth: 100,
            flex: 1,
            headerAlign: "center",
            headerClassName: itemGridHeadClass,
            align: "center",
            renderCell: ({ row }) =>
            (
                <div>
                    {funIsFooter(row.id) ? "" : row[RowsField.pcs]
                    }
                </div>)
        },
        {
            field: RowsField.weight,
            headerName: "Weight",
            minWidth: 100,
            flex: 1,
            headerAlign: "center",
            headerClassName: itemGridHeadClass,
            align: "center",
            renderCell: ({ row }) =>
            (
                <div>
                    {funIsFooter(row.id) ? "" : row[RowsField.weight]
                    }
                </div>)
        },
        {
            field: RowsField.bPcs,
            headerName: "Bal Pcs",
            minWidth: 100,
            flex: 1,
            headerAlign: "center",
            headerClassName: itemGridHeadClass,
            align: "center",
            renderCell: ({ row }) =>
            (
                <div>
                    {funIsFooter(row.id) ? "" : row[RowsField.bPcs]
                    }
                </div>)
        },
        {
            field: RowsField.bWeight,
            headerName: "Bal Weight",
            minWidth: 100,
            flex: 1,
            headerAlign: "center",
            headerClassName: itemGridHeadClass,
            align: "center",
            renderCell: ({ row }) =>
            (
                <div>
                    {funIsFooter(row.id) ? "" : row[RowsField.bWeight]
                    }
                </div>)
        },
        {
            field: RowsField.rate,
            headerName: "Rate",
            minWidth: 100,
            flex: 1,
            headerAlign: "center",
            headerClassName: itemGridHeadClass,
            align: "center",
            renderCell: ({ row }) =>
            (
                <div>
                    {funIsFooter(row.id) ? "" : row[RowsField.rate]
                    }
                </div>)
        },
        {
            field: RowsField.dRate,
            headerName: "Rate($)",
            minWidth: 100,
            flex: 1,
            headerAlign: "center",
            headerClassName: itemGridHeadClass,
            align: "center",
            renderCell: ({ row }) =>
            (
                <div>
                    {funIsFooter(row.id) ? "" : row[RowsField.dRate]
                    }
                </div>)
        },

        {
            field: RowsField.amount,
            headerName: "Amount",
            minWidth: 100,
            flex: 1,
            headerAlign: "center",
            headerClassName: itemGridHeadClass,
            align: "center",
            renderCell: ({ row }) =>
            (
                <div>
                    {funIsFooter(row.id) ? "" : row[RowsField.amount]
                    }
                </div>
            )
        },
        {
            field: RowsField.dAmount,
            headerName: "Amount($)",
            minWidth: 100,
            flex: 1,
            headerAlign: "center",
            headerClassName: itemGridHeadClass,
            align: "center",
            renderCell: ({ row }) =>
            (
                <div>
                    {funIsFooter(row.id) ? "" : row[RowsField.dAmount]
                    }
                </div>)
        },
    ]
    const funGetMasterLink = () => {
        if (selPktType == 'MIX')
            return naviCode + strdtype + "/" + sptype + linksUrl.mixEntry + linksUrl.stockEntry.stockEntryMaster
        else
            return naviCode + strdtype + "/" + sptype + linksUrl.stockEntry.stockEntryMaster
    }

    const handleClickPrev = () => {
        navigate(funGetMasterLink())
    }
    const setColumnRequired = (column) => {
        if (modSettingParams && modSettingParams?.Mandatory) {
            return Object.keys(modSettingParams?.Mandatory).length > 0 ? modSettingParams?.Mandatory[column] : false
        }
        else
            return false
    }

    const setColumnVisiblity = (column) => {
        if (column == RowsField.pcs || column == RowsField.weight || column == RowsField.rate || column == RowsField.amount)
            return true
        else {
            if (modSetting && Object.keys(modSetting).length > 0) {
                return modSettingParams && Object.keys(modSettingParams).length > 0 ? modSettingParams?.Visibility[column] : true
            }
            else
                return true
        }
    }

    const ValidateGrid = () => {
        let no = 0
        let msg = ""
        if (rows.length > 0) {
            for (let i = 0; i < rows.length; i++) {
            }
        }
        else {
            msg = "Add Atleast One  Item"
            no = 1
        }
        if (no)
            return msg + " is required"
        else return ""
    }

    const funSubmit = () => {
        const validate_form = validateForm()
        const grid_msg = isExcelImport ? "" : ValidateGrid()

        let t_Amt = 0
        let t_pcs = excelData.length
        let rowsData = rows;

        const data = excelData.map((ele, index) => {
            if (ele.hasOwnProperty("bweight") && ele.hasOwnProperty("brate")) {
                t_Amt += parseFloat(ele?.bweight ?? 0) * parseFloat(ele?.brate ?? 0)

            }
        })

        const t_weight = calculateTotal({
            data: excelData,
            columnName: "bweight"
        })

        if (!isNewEntry && selPktType == 'SNG') {
            rowsData = rowsData.filter((ele) => (ele.bWeight > 0 || ele.detailId == 0) && ele.isCertiDataExist == 0)
        }
        console.log(excelData, "exl")
        if (grid_msg == "") {
            funAddUpdate({
                data: {
                    comp_code: compCode.join(","),
                    item_list: isExcelImport ? excelData : rowsData,
                    deleteditem_list: deletedItemRows,
                    trans_id: formData[formField.transId],
                    bill_type: formData.stockType == ENUM_STOCK_TYPE.NewInward ? 'J' : 'O',// selBillType,
                    trade_of: selTradeOf,
                    nos: isExcelImport ? t_pcs : Number(total_Pcs),
                    weight: isExcelImport ? t_weight : total_Weight,
                    book_id: formData[formField.bookAcId],
                    location_id: formData[formField.locationId],
                    lab_id: formData[formField.lab],
                    pkt_type: selPktType == 'SNG' ? selPktType : '',
                    challan_no: formData[formField.memoNo],
                    challan_date: formData[formField.memoDate],
                    net_amount: isExcelImport ? t_Amt : net_Amount,
                    mkt_lotno: selPktType == 'SNG' ? isUseMfgNoAsMktno ? 0 : mktLotNo : 0,
                    is_xlimport: isExcelImport,
                    xlimport_item: selImportItem,
                    login_userid: user.username,
                    fystart_date: dayjs(startDate).format("YYYY-MM-DD"),
                    fyend_date: dayjs(endDate).format("YYYY-MM-DD"),
                    rec_status: !isNewEntry ? 1 : 2
                }
            })
        }
        else {
            submitLockRef.current = false;
            toast.error(grid_msg, {
                "position": "top-center"
            })
        }
    }
    const handleSubmit = (e) => {
        e.preventDefault()
        setSubmitBtnId(e.nativeEvent.submitter.id)
        // console.log(isUseMfgNoAsMktno, mktLotNo, "sub")
        if (selPktType == 'SNG' && !isUseMfgNoAsMktno && (mktLotNo == '' || mktLotNo == null || mktLotNo == '0')) {
            toast.error("Marketing Lot No Series Not Found", {
                "position": "top-center",
            })
            return;
        }
        if (isExcelImport && excelData.length <= 0) {
            show(<div className="text-red-700 text-sm" >No Data Found To Upload. <div className="text-gray-700 list-disc ml-5">
                {dupMarketingCode?.length > 0 ? "Duplicate Lot No / Pkt No found in stock. Only new   Lot/Pkt entries are allowed. Existing Lot/Pkt cannot be uploaded." : ""}
            </div></div>)
            if (fileInputRef.current) {
                fileInputRef.current.value = ''; // Clear file input
            }
            return;
        }
        if (submitLockRef.current) return;
        submitLockRef.current = true;
        if (selPktType == 'SNG') {
            let lotPktString = rows
                .filter(item => item.lotNo && item.pktNo && item.detailId == 0)
                .map(item => `${item.lotNo}-${item.pktNo}`)
                .join(",");

            if (lotPktString && lotPktString.length != "" && lotPktString.length > 0) {
                funGetDupPktList({
                    data: {
                        compcode: compCode.join(","),
                        list: lotPktString,
                        Ismfglist: 0,
                        Ischkmfgmkt: 0
                    },
                    onSuccess: (data) => {
                        if (!submitLockRef.current) return; // 🚫 ignore stale calls
                        if (data && data.length > 0) {
                            const result = data
                                .map(item => `${item.L_CODE}-${item.PKTNO}`)
                                .join(",");
                            show(<div className="text-red-700 text-sm" >Duplicate Stock Lot No. & Pkt No. {<div className="text-gray-700 list-disc ml-5">
                                {result}
                            </div>}</div>)
                            submitLockRef.current = false;
                            return;

                        }
                        else {
                            funSubmit()
                        }


                    }
                });
            }
            else
                funSubmit()
            // console.log(ExcelColMap)
        }
        else {
            funSubmit();
        }




    }

    const funGetStockType = (billType) => {
        if (billType == 'J')
            return ENUM_STOCK_TYPE.NewInward
        else
            return ENUM_STOCK_TYPE.OpeningStock
    }

    useEffect(() => {
        if (!isNewEntry && detailParams && Object.keys(detailParams)?.length > 0) {

            setIsExcelImport(false)
            setRows(gridData)
            setAllRows(gridData)
            if (!isUseMfgNoAsMktno && gridData.length > 0) {
                setMktLotNo(gridData[0].lotNo ?? '')
            }

            if (detail &&
                detail?.itemData &&
                detail?.itemData.length > 0) {
                let labId = ""
                if (gridData && gridData.length > 0) {
                    const uniquelab = [...new Set(gridData.map(item => item[RowsField.lab]))];
                    if (uniquelab.length > 0)
                        labId = uniquelab[0]
                }

                setFormData({
                    ...formData,
                    [formField.transId]: detail?.itemData[0]?.TransactionId ?? "",
                    [formField.locationId]: detail?.itemData[0]?.Lac_Id ?? "",
                    [formField.memoNo]: detail?.itemData[0]?.Chal_No ?? "",
                    [formField.memoDate]: detail?.itemData[0]?.Chal_Date ?? "",
                    [formField.bookAcId]: detail?.itemData[0]?.Ac_Id ?? "",
                    [formField.lab]: labId ?? "",
                    [formField.stockType]: funGetStockType(detail?.itemData[0]?.Bill_Type ?? ""),
                })
            }
        }

    }, [detail, masterData])

    const handleCheckChange = (value) => {
        setIsExcelImport(value)
        setRows([])
        setAllRows([])
    }
    const [excelData, setExcelData] = useState([]);


    const columnMapping = useMemo(() => {
        const d = excelTempData.map((row) => {
            return {
                [row.xl_col_no]: row.tb_col_name
            }
        })

        const flipped = d.reduce((acc, obj) => {
            const [key, value] = Object.entries(obj)[0];
            acc[value] = key;
            return acc;
        }, {});
        return flipped
    }, [excelTempData])



    const handleFileUpload = (e) => {
        const file = e.target.files[0];
        const reader = new FileReader();
        //const StockSingleColumn = 0
        reader.onload = (event) => {
            const binaryStr = event.target.result;
            const workbook = XLSX.read(binaryStr, { type: 'binary' });
            const worksheetName = workbook.SheetNames[0];
            const worksheet = workbook.Sheets[worksheetName];
            const jsonData = XLSX.utils.sheet_to_json(worksheet);
            const rows = XLSX.utils.sheet_to_json(worksheet, { header: 1 });
            // setExcelData(jsonData);
            const dataRows = rows.slice(1); // remove this if there's no header row
            const headers = rows[0];
            // console.log(columnMapping,rows[0], Object.keys(columnMapping).length, headers.length)

            let spktno = ''
            let slcode = ''
            setTotalExcelPacket(dataRows.length)
            const dbDuplicateSet = new Set();
            if (headers.length == Object.keys(columnMapping).length) {

                const mapped = dataRows.filter((r) => r.length !== 0).map((row, ind) => {

                    //if (row.length > 0) {
                    const finalData = Object.entries(columnMapping).map(([key, value]) => {

                        if (key == 'stoneid' && selPktType == 'SNG' && isMKTIdSingleColum) {
                            let val = row[Number(value.toString()) - 1] ?? ''

                            if (val != "") {

                                if (String(val).includes("-")) {
                                    // const sData = val.split('-');
                                    const [left, right] = String(val).split("-");

                                    if (left?.trim() && right?.trim()) {
                                        // if (sData && sData.length > 0) {
                                        return { l_code: left, pktno: right, [key]: row[Number(value.toString()) - 1] ?? null }
                                    }
                                    else {

                                        toast.error("Invalid Stock Format LotNo & PktNo Should Not be Empty'  ", {
                                            "position": "top-center",
                                            "className": "toast-error",
                                            "toastId": "stkial"
                                        })
                                        if (fileInputRef.current) {
                                            fileInputRef.current.value = ''; // Clear file input
                                        }
                                        return { [key]: row[Number(value.toString()) - 1] ?? null }
                                    }
                                }
                                else {
                                    if (toast && !toast.isActive("stkinval")) {
                                        toast.error("Invalid Stock Format LotNo & PktNo Must Be Seperated Using ' - '  ", {
                                            "position": "top-center",
                                            "className": "toast-error",
                                            "toastId": "stkinval"
                                        })
                                    }
                                    if (fileInputRef.current) {
                                        fileInputRef.current.value = ''; // Clear file input
                                    }
                                    return { [key]: row[Number(value.toString()) - 1] ?? null }
                                }
                            }
                        }
                        else if (key == 'mfgstoneid' && selPktType == 'SNG' && isMFGIdSingleColum) {

                            let val = row[Number(value.toString()) - 1] ?? ''
                            if (val != "") {
                                if (String(val).includes("-")) {
                                    //  const sData = val.split('-');
                                    const [left, right] = String(val).split("-");

                                    if (left?.trim() && right?.trim()) {
                                        // if (sData && sData.length > 0) {
                                        return { sl_code: left, spktno: right, [key]: row[Number(value.toString()) - 1] ?? null }
                                    }
                                    else {
                                        toast.error("Invalid Stock Format  Mfg LotNo & PktNo Should Not be Empty'  ", {
                                            "position": "top-center",
                                            "className": "toast-error",
                                            "toastId": "stkial"
                                        })
                                        if (fileInputRef.current) {
                                            fileInputRef.current.value = ''; // Clear file input
                                        }
                                        return { [key]: row[Number(value.toString()) - 1] ?? null }
                                    }
                                }
                                else {
                                    if (toast && !toast.isActive("stkinval")) {
                                        toast.error("Invalid Mfg Stock Format LotNo & PktNo Must Be Seperated Using ' - '  ", {
                                            "position": "top-center",
                                            "className": "toast-error",
                                            "toastId": "stkinval"
                                        })
                                    }
                                    if (fileInputRef.current) {
                                        fileInputRef.current.value = ''; // Clear file input
                                    }
                                    return { [key]: row[Number(value.toString()) - 1] ?? null }
                                }
                            }
                        }
                        else {
                            return {
                                [key]: row[Number(value.toString()) - 1] ?? null
                            }
                        }

                        // if (key == 'mfgstoneid' && selPktType == 'SNG' && isMFGIdSingleColum) {
                        //     console.LOG("HI")
                        //     let val = row[Number(value.toString()) - 1] ?? ''
                        //     if (val != "") {
                        //         if (String(val).includes("-")) {
                        //             //  const sData = val.split('-');
                        //             const [left, right] = String(val).split("-");

                        //             if (left?.trim() && right?.trim()) {
                        //                 // if (sData && sData.length > 0) {
                        //                 return { sl_code: left, spktno: right, [key]: row[Number(value.toString()) - 1] ?? null }
                        //             }
                        //             else {
                        //                 toast.error("Invalid Stock Format  Mfg LotNo & PktNo Should Not be Empty'  ", {
                        //                     "position": "top-center",
                        //                     "className": "toast-error",
                        //                     "toastId": "stkial"
                        //                 })
                        //                 if (fileInputRef.current) {
                        //                     fileInputRef.current.value = ''; // Clear file input
                        //                 }
                        //                 return { [key]: row[Number(value.toString()) - 1] ?? null }
                        //             }
                        //         }
                        //         else {
                        //             if (toast && !toast.isActive("stkinval")) {
                        //                 toast.error("Invalid Mfg Stock Format LotNo & PktNo Must Be Seperated Using ' - '  ", {
                        //                     "position": "top-center",
                        //                     "className": "toast-error",
                        //                     "toastId": "stkinval"
                        //                 })
                        //             }
                        //             if (fileInputRef.current) {
                        //                 fileInputRef.current.value = ''; // Clear file input
                        //             }
                        //             return { [key]: row[Number(value.toString()) - 1] ?? null }
                        //         }
                        //     }
                        // }
                        // else {
                        //     return {
                        //         [key]: row[Number(value.toString()) - 1] ?? null
                        //     }
                        // }
                    })
                    //  }
                    //console.log(finalData)
                    const result = finalData.reduce((acc, obj) => {
                        if (obj && typeof obj === 'object') {
                            Object.entries(obj).forEach(([key, value]) => {
                                acc.push({ [key]: value });
                            });
                        }
                        return acc;
                    }, [])
                    const finalresult = result.reduce((acc, obj) => {
                        return { ...acc, ...obj }
                    })

                    return finalresult

                });
                if (selPktType == 'SNG') {
                    if (mapped && mapped.length > 0) {
                        let mapLotPktList = []
                        if (isMKTIdSingleColum)
                            mapLotPktList = mapped.map((ele) => ele.stoneid)
                        else {

                            mapLotPktList = mapped.map((ele) => ele.l_code == '' || ele.l_code == null ? mktLotNo + "-" + ele.pktno : ele.l_code + "-" + ele.pktno)

                        }

                        funGetDupPktList({
                            data: {
                                compcode: compCode.join(","),
                                list: mapLotPktList.join(","),
                                Ismfglist: 0,
                                Ischkmfgmkt: 0
                            },
                            onSuccess: (data) => {
                                // console.log(mapLotPktList)
                                if (data && data.length > 0) {

                                    setDupMarketingCode(data)
                                    // if (!isUseMfgNoAsMktno) {
                                    const filtered = mapped.filter(item =>
                                        !data.some(ex =>
                                            ex.PKTNO === item.pktno && ex.L_CODE === item.l_code
                                        )
                                    );
                                    setExcelData(filtered);
                                    if (filtered && filtered.length <= 0) {
                                        if (fileInputRef.current) {
                                            fileInputRef.current.value = ''; // Clear file input
                                        }
                                    }
                                    //}
                                }
                                else {
                                    setExcelData(mapped);
                                    setDupMarketingCode([])
                                }

                            }
                        })
                    }
                    if (!isUseMfgNoAsMktno) {
                        const allHaveKeys = mapped.every(
                            obj => obj.hasOwnProperty("sl_code") && obj.hasOwnProperty("spktno")
                        );
                        if (allHaveKeys) {
                            let mapLotPktList = []
                            if (isMFGIdSingleColum)
                                mapLotPktList = mapped.map((ele) => ele.mfgstoneid)
                            else
                                mapLotPktList = mapped.map((ele) => ele.sl_code + "-" + ele.spktno)
                            funGetDupPktList({
                                data: {
                                    compcode: compCode.join(","),
                                    list: mapLotPktList.join(","),
                                    Ismfglist: 1,
                                    Ischkmfgmkt: 0
                                },
                                onSuccess: (data) => {
                                    if (data && data.length > 0) {
                                        setDupMfgCode(data)
                                    }
                                    else
                                        setDupMfgCode([]);

                                }
                            })
                        }

                    }
                }
                setExcelData(mapped)

            }
            else {
                if (fileInputRef.current) {
                    fileInputRef.current.value = ''; // Clear file input
                }
                toast.error("Excel File No of Columns Mis-Match", {
                    "position": "top-center",
                    "className": "toast-error"
                })

            }

        };
        reader.readAsBinaryString(file);
    }

    const valueFields = [RowsField.rate, RowsField.amount, RowsField.convRate, RowsField.dRate, RowsField.dAmount];
    const funSetStockFormSetting = (column) => {
        if (valueFields.includes(column))
            return setCurrencyColumnVisiblity(column)
        else
            return setColumnVisiblity(column)
    }
    // useEffect(() => {
    //        const cleanup = scrollInput({ ignoreRefs: [] });
    //        return () => cleanup();
    //    }, []);
    const handleDownloadExcel = () => {
        // File: ExportExcel.js
        // Define headersif()

        const data = [...excelTempData];

        const sortedData = data.sort((a, b) => Number(a.xl_col_no) - Number(b.xl_col_no));

        const headers = sortedData.map(ele => ele.xl_col_name)
        //if (headers && headers.length > 0) {
        //  Create a worksheet with headers only
        const ws = XLSX.utils.aoa_to_sheet([headers]);

        // Create a new workbook and append the worksheet
        const wb = XLSX.utils.book_new();
        XLSX.utils.book_append_sheet(wb, ws, "Sheet1");

        // Generate Excel file buffer
        const wbout = XLSX.write(wb, { bookType: "xlsx", type: "array" });

        // Trigger download with FileSaver
        const blob = new Blob([wbout], { type: "application/octet-stream" });
        saveAs(blob, selPktType == "SNG" ? "SinglePacketStockUploadFormat.xlsx" : "MixStockUploadFormat");


    }
    const handleDateChange = (newValue) => {

        const cdate = newValue != '' && newValue != 'Invalid Date' ? dayjs(newValue).format("YYYY-MM-DD") : null

        setFormData((prev) => {
            return {
                ...prev,
                [formField.memoDate]: cdate,
            };
        });
        if (cdate && cdate != "Invalid Date") {
            funMktLotNo(cdate)
        }
    }

    const handleDateBlur = (e, name) => {
        const input = e.target.value.trim();   // "DD/MM/YYYY"

        if (!input) return;

        // Parse typed date strictly as DD/MM/YYYY
        const parsed = dayjs(input, "DD/MM/YYYY", true);

        // ❌ Invalid format or wrong date typed
        // if (!parsed.isValid()) {
        //     toast.error("Invalid date format. Use DD/MM/YYYY", {
        //         position: "top-center",
        //         className: "toast-error"
        //     });
        //     return;
        // }

        // // ❌ Out of allowed range
        // if (parsed.isBefore(minAllowedDate) || parsed.isAfter(maxAllowedDate)) {
        //     toast.error(`Date must be between ${minAllowedDate.format("DD/MM/YYYY")} and ${maxAllowedDate.format("DD/MM/YYYY")}`, {
        //         position: "top-center",
        //         className: "toast-error"
        //     });
        //     setFormData({ ...formData, [name]: null })
        //     return;
        // }

        // Convert to API format
        const formatted = parsed.format("YYYY-MM-DD");


        setFormData(prev => {
            const updated = { ...prev, [name]: formatted };
            return updated;
        });
        if (formatted && formatted != "Invalid Date") {
            funMktLotNo(formatted)
        }
    };
    const downloadTextFile = () => {
        let content = "Total No oF Packets:" + totalExcelPacket + "\n\n";

        let uploadPkt = excelData.length
        if (excelData.length > dupMfgCode.length)
            uploadPkt = excelData.length - dupMfgCode.length
        else
            uploadPkt = dupMfgCode.length - excelData.length

        content += "Total No oF New Packets :" + uploadPkt + "\n\n";
        if (dupMfgCode.length > 0)
            content += "Total No oF Packets To UpDate :" + dupMfgCode.length + "\n\n";

        if (dupMarketingCode?.length > 0) {
            content += "Duplicate Marketing Nos: ( " + dupMarketingCode.length + " )\n";
            dupMarketingCode.forEach((ele) => {
                content += `${ele.L_CODE}-${ele.PKTNO}, `;
            });
            content += "\n\n";
        }

        if (dupMfgCode?.length > 0) {
            content += "Duplicate Manufacturing Nos: ( " + dupMfgCode.length + " )\n";
            dupMfgCode.forEach((ele) => {
                content += `${ele.SL_CODE}-${ele.SPKTNO}, `;
            });
            content += "\n\n";
        }

        const today = new Date();
        const formattedDate = today.toISOString().slice(0, 10); // "2025-01-15"

        const fileName = `StockImportLogs-${formattedDate}.txt`

        const blob = new Blob([content], { type: "text/plain" });
        const url = URL.createObjectURL(blob);

        const a = document.createElement("a");
        a.href = url;

        a.download = fileName
        a.click();

        URL.revokeObjectURL(url);
    };


    const searchInAllKeys = (data, searchText) => {
        if (!searchText) return data;

        const lowerSearch = searchText.toLowerCase();

        return data.filter(item =>
            Object.values(item).some(val =>
                val !== null &&
                val !== undefined &&
                val.toString().toLowerCase().includes(lowerSearch)
            )
        );
    };
    useEffect(() => {

    }, [])
    useEffect(() => {
        const searchData = searchInAllKeys(allRows, searchText)

        setRows(searchData)

    }, [searchText])

    useEffect(() => {
        if (!isLoadingDupPktList) {

            if (
                (dupMarketingCode && dupMarketingCode.length > 0) ||
                (dupMfgCode && dupMfgCode.length > 0)
            ) {
                downloadTextFile();   // auto download
            }
        }
    }, [dupMarketingCode, dupMfgCode, isLoadingDupPktList]);


    if (isError) {

        return <ErrorCard />
    }
    if (isPending) {
        return <LoadingCard />
    }

    return (
        <div>

            <MainContainer
                pageName={`${isNewEntry ? "New" : "Update"} ${entryLabel}   Stock Entry - ${selPktType == 'SNG' ? "Single Packet" : selPktType}`}
                breadcrumbs={[entryLabel, "Stock Entry", selPktType == 'SNG' ? "Single Packet" : selPktType]}
                prevPage={{
                    show: true,
                    onClick: handleClickPrev,
                }}
            >

                <Card shadow="sm" className={stickyParentClass}>
                    <form onSubmit={handleSubmit} autoComplete='off'>
                        <CardBody>
                            {
                                Object.keys(inputBoxes).map((key, ind) => (
                                    <div key={key + ind}>
                                        <div className={` ${isMobile ? 'flex-wrap' : ''}   flex gap-4 align-top items-baseline mb-2 `}>
                                            {
                                                inputBoxes[key].map((item, indx) =>
                                                    item.type == ENUM_INPUT_TYPE.select ? (
                                                        <></>
                                                    ) : item.type == ENUM_INPUT_TYPE.autocomplete ? (
                                                        <Autocomplete
                                                            size="md"
                                                            name={item.name}
                                                            //isInvalid={errors[item.name]}
                                                            //  errorMessage={errors[item.name]}
                                                            label={item?.placeholder}
                                                            eventResizeFeature={true}
                                                            selectionMode="single"
                                                            showScrollIndicators={true}
                                                            labelPlacement={"outside"}
                                                            placeholder={item.placeholder}
                                                            isRequired={item.isrequired}
                                                            menuTrigger={"input"}
                                                            isLoading={isPendingData}
                                                            className="max-w-23"
                                                            classNames={{
                                                                label: "text-xs text-black font-bold",
                                                            }}
                                                            isClearable={false}
                                                            isVirtualized
                                                            isReadOnly={[formField.stockType].includes(item.name) && !isNewEntry ?
                                                                true : false}
                                                            defaultItems={
                                                                item.data ? item.data : []
                                                            }
                                                            onSelectionChange={(e) =>
                                                                handleAutoCompleteChange(e, '', item.name)
                                                            }
                                                            //                                                            color={item.id == formField.debitAcId ? "success" : item.id == formField.creditAcId ? "primary" : ""}
                                                            //onChange={handleFormSelectionChange}
                                                            selectedKey={formData[item.name]}
                                                        >
                                                            {(list) => (
                                                                <AutocompleteItem

                                                                    key={list[item.itemkey]}
                                                                >
                                                                    {list[item.itemvalue]}
                                                                </AutocompleteItem>
                                                            )}
                                                        </Autocomplete>
                                                    ) : item.type == ENUM_INPUT_TYPE.date ? (
                                                        <div className=" w-full flex items-center">
                                                            <LocalizationProvider dateAdapter={AdapterDayjs}>
                                                                <DatePicker
                                                                    label={item.placeholder}
                                                                    views={["day", "month", "year"]}
                                                                    format="DD/MM/YYYY"
                                                                    value={
                                                                        formData[item.name]
                                                                            ? dayjs(formData[item.name])
                                                                            : formData[item.name]
                                                                    }
                                                                    onChange={(newValue) => handleDateChange(newValue)}
                                                                    //isRequired={item.required}
                                                                    className="w-full "
                                                                    slotProps={{
                                                                        textField: { size: "small", onBlur: (e) => handleDateBlur(e, item.name), required: true },
                                                                    }}
                                                                />
                                                            </LocalizationProvider>
                                                        </div>
                                                    ) : (

                                                        <Input
                                                            type={item.type}
                                                            name={item.name}
                                                            id={item.name}
                                                            //isInvalid={errors[item.name]}
                                                            //errorMessage={errors[item.name]}
                                                            placeholder={item.placeholder}
                                                            label={item.placeholder}
                                                            labelPlacement="outside"
                                                            isRequired={item.isrequired}
                                                            value={formData[item.name]}
                                                            variant="bordered"
                                                            onChange={(e) => handleChange(e)}
                                                            onBlur={(e) => handleBlur(e)}
                                                            isReadOnly={item.name == [formField.memoNo] ? true : false}
                                                            size={"md"}
                                                            classNames={{
                                                                label: "text-xs text-black font-bold",
                                                            }}
                                                        ></Input>
                                                    )
                                                )
                                            }
                                        </div>
                                    </div>
                                ))
                            }
                            {
                                isNewEntry ?
                                    <div className={`${isMobile ? "flex-wrap" : ""} text-center  mt-2 flex gap-4 justify-center items-center w-full mb-2`}>
                                        <Checkbox size="md"
                                            classNames={{ "label": "text-blue-500 font-semibold" }}
                                            className="py-1 px-2  border-blue-200 text-rose-700 border-2" label="gfu" color={"success"} isSelected={isExcelImport}
                                            onValueChange={(e) => handleCheckChange(e)}>Import From Excel</Checkbox>
                                        <Button size="sm" auto color="warning" onPress={handleDownloadExcel} className="ml-4"
                                            startContent={<FontAwesomeIcon icon={faDownload} />} >
                                            Stock Upload Excel Format
                                        </Button>
                                    </div> : ""
                            }
                            {isExcelImport && isNewEntry ?
                                <div className="py-2">
                                    {isLoadingDupPktList ? <div className=" flex gap-1 p-2 justify-center font-semibold border-0 b-red-500 text-pink-700 text-center ">
                                        <h2 className=" px-2" >Proccessing....</h2>
                                        <Spinner size="sm" label="" className="" variant="simple" color="danger" labelColor="danger" />
                                    </div> : ""}
                                    <Input type="file" color="danger" size="md" variant="flat" ref={fileInputRef}
                                        classNames={{ label: "text-lg text-slate-700 font-semibold" }}
                                        isRequired={isExcelImport}
                                        label="Import From Excel" accept=".xlsx, .xls" onChange={handleFileUpload} ></Input>

                                    <Autocomplete
                                        size="md"
                                        name={"ImportItem"}
                                        label={"Select Item"}
                                        eventResizeFeature={true}
                                        selectionMode="single"
                                        showScrollIndicators={true}
                                        labelPlacement={"outside"}
                                        variant="faded"
                                        color="default"
                                        menuTrigger={"input"}
                                        placeholder={""}
                                        isRequired={isExcelImport ? true : false}
                                        isLoading={isPendingData}
                                        className="max-w-23"
                                        classNames={{
                                            label: "text-xs text-black font-bold",
                                        }}
                                        isClearable={false}
                                        isVirtualized
                                        readonly={isNewEntry ? false : true}
                                        defaultItems={
                                            masterData && masterData.itemMaster ? masterData.itemMaster : []
                                        }
                                        onSelectionChange={setSelImportItem}                                        //color={item.id == formField.debitAcId ? "success" : item.id == formField.creditAcId ? "primary" : ""}
                                        selectedKey={selImportItem}
                                    >
                                        {(list) => (
                                            <AutocompleteItem

                                                key={list.Item_Code}
                                            >
                                                {list.Item_Desc}
                                            </AutocompleteItem>
                                        )}
                                    </Autocomplete>
                                    {excelData && excelData.length > 0 ? <h2 className="text-red-600 mt-3 font-semibold  p-2 bg-gray-50"> Total Packets Scheduled For Import: {excelData.length} </h2> : ""}

                                    {dupMarketingCode && dupMarketingCode.length > 0 ? (
                                        <div className=" bg-red-50 p-2 text-sm mt-2">
                                            <h2 className="p-2  text-sm  font-semibold text-blue-700">   Duplicate Marketing Nos:</h2>
                                            <div className="flex gap-2 flex-wrap">
                                                {dupMarketingCode.map((ele, i) => (
                                                    <div key={i}>
                                                        {ele.L_CODE}-{ele.PKTNO} ,
                                                    </div>
                                                ))}
                                            </div>
                                        </div>
                                    ) : null}
                                    {dupMfgCode && dupMfgCode.length > 0 ? (
                                        <div className=" bg-lime-50 p-2 text-sm mt-2">
                                            <h2 className="p-2  text-sm  font-semibold text-blue-700">   Duplicate Manufacturing Nos:</h2>
                                            <div className="flex gap-2 flex-wrap">
                                                {dupMfgCode.map((ele, i) => (
                                                    <div key={i}>
                                                        {ele.SL_CODE}-{ele.SPKTNO} ,
                                                    </div>
                                                ))}
                                            </div>
                                        </div>
                                    ) : null}


                                </div> : ""}
                            <div>
                                {isExcelImport ? "" :
                                    <div className="flex justify-between items-center">
                                        <Button size="sm" color="success" radius="sm" className="text-white cursor-pointer  text-xs bg-emerald-600" startContent={<FontAwesomeIcon color="white" icon={faGem} />}
                                            onPress={handleAddRow}>
                                            ADD STOCK
                                        </Button>
                                        <h6 className="text-sm text-green-700" >Total Items : {rows && rows.length > 0 ? rows.length : 0}</h6>
                                    </div>
                                }
                                <Drawer open={openDrawer} anchor="top">
                                    {/* <FontAwesomeIcon onClick={() => setOpenDrawer(false)} className=" p-3 cursor-pointer text-blue-800 text-3xl absolute right-0" icon={faSquareXmark} /> */}

                                    <div className="text-center font-semibold uppercase p-1 text-gray-700 border-b-2 border-orange-500">
                                        Stock Item
                                    </div>
                                    <div className="p-5">
                                        {
                                            Object.keys(stockInputBoxes).map((key, ind) => (
                                                <div key={key + ind}>
                                                    <div className={` ${isMobile ? 'flex-wrap' : ''}   flex gap-4 align-top items-baseline mb-2 `}>
                                                        {
                                                            stockInputBoxes[key].map((item, indx) =>
                                                                item.type == ENUM_INPUT_TYPE.autocomplete ?
                                                                    (
                                                                        funSetStockFormSetting(item.name) ?
                                                                            <Autocomplete
                                                                                size="md"
                                                                                name={item.name}
                                                                                isInvalid={errors[item.name]}
                                                                                errorMessage={errors[item.name]}
                                                                                label={item?.placeholder}
                                                                                eventResizeFeature={true}
                                                                                selectionMode="single"
                                                                                showScrollIndicators={true}
                                                                                labelPlacement={"outside"}
                                                                                menuTrigger={"input"}
                                                                                variant="faded"
                                                                                color="default"
                                                                                placeholder={item.placeholder}
                                                                                isRequired={true}
                                                                                isLoading={isPendingData}
                                                                                className="max-w-23"
                                                                                classNames={{
                                                                                    label: "text-xs text-black font-bold",
                                                                                }}
                                                                                isClearable={false}
                                                                                isVirtualized

                                                                                readonly={isNewEntry ? false : true}
                                                                                defaultItems={
                                                                                    item.data ? item.data : []
                                                                                }
                                                                                onSelectionChange={(e) =>
                                                                                    handleAutoCompleteChange(e, '', item.name)
                                                                                }
                                                                                //color={item.id == formField.debitAcId ? "success" : item.id == formField.creditAcId ? "primary" : ""}
                                                                                selectedKey={stockFormData[item.name]}
                                                                            >
                                                                                {(list) => (
                                                                                    <AutocompleteItem

                                                                                        key={list[item.itemkey]}
                                                                                    >
                                                                                        {list[item.itemvalue]}
                                                                                    </AutocompleteItem>
                                                                                )}
                                                                            </Autocomplete>
                                                                            : ""
                                                                    ) : (
                                                                        funSetStockFormSetting(item.name) ?
                                                                            <Input
                                                                                type={item.type}
                                                                                name={item.name}
                                                                                id={item.name}
                                                                                ref={item.name == RowsField.pktNo ? refInputPktNo : refInput}
                                                                                isInvalid={errors[item.name]}
                                                                                errorMessage={errors[item.name]}
                                                                                placeholder={item.placeholder}
                                                                                label={item.placeholder}
                                                                                labelPlacement="outside"
                                                                                //isRequired={true}
                                                                                value={stockFormData[item.name]}
                                                                                isReadOnly={item.readonly}
                                                                                variant={item?.color ? "flat" : "bordered"}
                                                                                onChange={(e) => handleStockChange(e)}
                                                                                onBlur={(e) => handleBlur(e)}
                                                                                //&& formData[RowsField.weight]<=0
                                                                                isDisabled={(selPktType == 'SNG'
                                                                                    && !isNewEntry && selectedRowId > 0 && formData[RowsField.weight] <= 0
                                                                                    && (item.name == RowsField.lotNo
                                                                                        || item.name == RowsField.pktNo)) ||
                                                                                    (selPktType != "SNG" && selTradeOf == "R" && item.name == RowsField.lotNo && !isNewEntry && selectedRowId > 0) ? true :
                                                                                    false}
                                                                                size={"md"}
                                                                                color={
                                                                                    item?.color ? item?.color : ""
                                                                                }
                                                                                classNames={{
                                                                                    label: "text-xs text-black font-bold",
                                                                                }}
                                                                            ></Input>
                                                                            : ""
                                                                    )
                                                            )
                                                        }
                                                    </div>
                                                </div>
                                            ))
                                        }

                                    </div>
                                    <div className="pb-5 text-center justify-center flex gap-4">
                                        <Button
                                            color="success"
                                            size="sm"
                                            variant="shadow"
                                            className=""
                                            onPress={handleAddStock}
                                            startContent={<FontAwesomeIcon icon={faPlus} />}
                                        >
                                            {btnLabel}
                                        </Button>
                                        <Button
                                            color="danger"
                                            size="sm"
                                            variant="shadow"
                                            className=""
                                            onPress={() => setOpenDrawer(false)}
                                            startContent={<FontAwesomeIcon icon={faClose} />}
                                        >
                                            Close
                                        </Button>
                                    </div>

                                </Drawer>
                                {isNewEntry && rows.length <= 0 ? "" :
                                    <div className="my-2">
                                        <Input type="text" size="sm"
                                            radius="none" placeholder="Search ...."
                                            startContent={<FontAwesomeIcon className="text-gray-700" icon={faSearchPlus}></FontAwesomeIcon>}
                                            variant="bordered" className="bg-white border-1 border-gray-300"
                                            value={searchText} onChange={(e) => setSearchText(e.target.value)}  ></Input>
                                    </div>}

                                {rows && rows?.length > 0 ? (
                                    <>

                                        <Box sx={{ height: rows.length > 10 ? 400 : "auto", width: '100%' }}>
                                            <DataGrid
                                                rows={rows}
                                                columns={columns}
                                                editMode="row"
                                                columnHeaderHeight={30}
                                                rowHeight={30}
                                                disableColumnSorting={true}
                                                disableColumnMenu={true}
                                                getRowClassName={(params) => {
                                                    if (params.id == selectedRowId)
                                                        return 'select-row'
                                                    return 'row-class';
                                                }}

                                                // getRowClassName={getRowClassName}
                                                sx={{
                                                    '& .MuiDataGrid-columnHeaders': {
                                                        position: 'sticky',
                                                        top: 0,
                                                        zIndex: 1, // Make sure the headers are above the rows when scrolling

                                                    },
                                                    '& .select-row': {
                                                        backgroundColor: "#ebe8e8"
                                                    },
                                                    '& .row-class': {
                                                        fontSize: "12px"
                                                    },
                                                    '& .sticky-row': {
                                                        position: 'sticky',
                                                        bottom: 0,
                                                        color: "#FFFFFF",
                                                        backgroundColor: '#424242f5',
                                                        zIndex: 10,
                                                    },
                                                    '& .sticky-row:hover': {
                                                        backgroundColor: "#424242f5"
                                                    }
                                                }}
                                                columnVisibilityModel={{
                                                    [RowsField.gridMktNo]: isUseMfgNoAsMktno ? false : true,
                                                    [RowsField.itemCode]: setColumnVisiblity(RowsField.itemCode),
                                                    [RowsField.lotNo]: setColumnVisiblity(RowsField.lotNo),
                                                    [RowsField.pktNo]: setColumnVisiblity(RowsField.pktNo),
                                                    [RowsField.sLotNo]: isUseMfgNoAsMktno ? false : true,
                                                    [RowsField.sPktNo]: isUseMfgNoAsMktno ? false : true,
                                                    [RowsField.shapeCode]: setColumnVisiblity(RowsField.shapeCode),
                                                    [RowsField.colorCode]: setColumnVisiblity(RowsField.colorCode),
                                                    [RowsField.purityCode]: setColumnVisiblity(RowsField.purityCode),
                                                    [RowsField.sizeCode]: setColumnVisiblity(RowsField.sizeCode),
                                                    [RowsField.lwRatio]: setColumnVisiblity(RowsField.lwRatio),
                                                    [RowsField.itemDetail]: setColumnVisiblity(RowsField.itemDetail),
                                                    [RowsField.bWeight]: selPktType == "SNG" ? true : false,
                                                    [RowsField.bPcs]: selPktType == "SNG" ? true : false,
                                                    [RowsField.rate]: setCurrencyColumnVisiblity(RowsField.rate),
                                                    [RowsField.dRate]: setCurrencyColumnVisiblity(RowsField.dRate),
                                                    [RowsField.amount]: setCurrencyColumnVisiblity(RowsField.amount),
                                                    [RowsField.dAmount]: setCurrencyColumnVisiblity(RowsField.dAmount),
                                                    [RowsField.convRate]: setCurrencyColumnVisiblity(RowsField.convRate),
                                                }}

                                            />

                                        </Box>
                                        <div className=" p-4 bg-gray-50 font-semibold">

                                            <div className="flex gap-4 justify-center items-center">
                                                Total
                                                <Input readOnly={true} label="Pcs" labelPlacement="outside" color="primary" value={total_Pcs} className="bg-sky-700" ></Input>
                                                <Input readOnly={true} label="Weight" labelPlacement="outside" color="danger" className="bg-rose-700" value={total_Weight}> </Input>
                                                <Input readOnly={true} label="Rate" labelPlacement="outside" color="default" className="bg-amber-500" value={total_Rate} >  </Input>
                                                <Input readOnly={true} label="Amount" labelPlacement="outside" color="success" className="bg-lime-500" value={net_Amount} > </Input>
                                                {CurrencySetting == ENUM_CURRENCY_SETTING_VAL.RS ? "" :
                                                    <Input readOnly={true} label="Amount ($)" labelPlacement="outside" color="warning" className="bg-lime-500" value={net_AmountD} > </Input>
                                                }
                                            </div>
                                        </div>
                                    </>
                                ) : (
                                    ""
                                )}
                            </div>
                        </CardBody>
                        <div className={stickyBottomClass}>
                            <div className="justify-center flex items-center gap-4">
                                {/* <div className="justify-center flex gap-5 mt-5"> */}
                                <Button
                                    color="primary"
                                    type="submit"
                                    id="btnSave"
                                    size="sm"
                                    variant="shadow"
                                    tabIndex={-1}
                                    isLoading={isPending}
                                    startContent={<FontAwesomeIcon icon={faSave} />}
                                >
                                    Submit
                                </Button>
                                <Button
                                    id="btnSaveNew"
                                    color="success"
                                    type="submit"
                                    size="sm"
                                    variant="shadow"
                                    className="text-white"
                                    startContent={<FontAwesomeIcon className=" text-md text-white" icon={faFile} />}
                                >
                                    Save & New
                                </Button>
                                <Button
                                    color="danger"
                                    variant="shadow"
                                    size="sm"
                                    tabIndex={-1}
                                    onPress={handleClickPrev}
                                    startContent={<FontAwesomeIcon icon={faCancel} />}
                                >
                                    Cancel
                                </Button>
                            </div>
                        </div>

                    </form >
                </Card >
            </MainContainer>
        </div>
    )
}
export default CreateStockEntry